import { useContext, useState, useEffect, useCallback } from 'react';
import './Graphs.css';
import { FormattedMessage } from 'react-intl';
import messages from '../lang/preferences';
import Axios from 'axios';
//import PageCharts from '../generics/PageCharts';
import { LanguageContext } from '../contexts/LanguageContext';
import { useHistory } from "react-router-dom";
import url from '../constants/urlsPaths';
import GroupComparison_en from '../ressources/group-comparison-en.png'
import GroupComparison_fr from '../ressources/group-comparison-fr.png'
import GroupComparison_de from '../ressources/group-comparison-de.png'

export default function Graphs({ token }) {
    const { locale } = useContext(LanguageContext);
    const [loading, setLoading] = useState(true);
    //const [graphs, setGraphs] = useState([]);
    //const [inputs, setInputs] = useState([]);
    const [showResults, setShowResults] = useState(false); // Use state for this
    const history = useHistory();

    const getResults = useCallback(() => {
        //Si log
        if (sessionStorage.getItem("code") && sessionStorage.getItem("token")) {
            Axios.post(url.getResults, { code: sessionStorage.getItem("code") }, {
                headers: { "x-access-token": JSON.parse(sessionStorage.getItem("token") || "null") }
            })
                .then(res => {
                    console.log("user data", res);
                    if (res.data.auth === false) {
                        sessionStorage.clear();
                        window.location.reload();
                    }
                    else {
                        //le user n'a jamais passé le test donc est redirigé (Admin ou user)
                        if (res.data.results === false) {
                            history.push('/');
                            console.log("Redirection");
                        }
                        else {
                            // This now correctly updates the state and triggers a re-render
                            setShowResults(!res.data.auth); // use this variable until there is an dedicated coach variable
                            //setGraphs(res.data.results);
                            //setInputs(res.data.answers);
                            setTimeout(function () {
                                setLoading(false);
                            }, 2000);
                        }
                    }
                })
                .catch(err => { console.log(err) });
        }
        //le user a effacé son sessionstorage manuellement donc redirigé vers la page de co
        else {
            sessionStorage.clear();
            window.location.reload();
        }
    }, [history]); // Add history as a dependency for useCallback

    useEffect(() => {
        if (!token) {
            sessionStorage.clear();
            window.location.reload();
        }
        else {
            getResults();
        }
    }, [getResults, token]);

    /*
    const _downloadInputsCSV = () => {
        const user = inputs;
        console.log(user);
        let text = "User Inputs \r \r";
        console.log(user)
        for (let i = 0; i < user.length; i++) {
            if (i >= 0 && i <= 33) { text += Object.keys(user[i]) + ";" + user[i][Object.keys(user[i])] + "\r" }
            if (i === 34) {
                text += "ASSUMPTION1;";
                for (let k = 0; k < Object.values(user[i]).length; k++) { text += Object.values(user[i])[k] + ";" }
                text += "\r";
            }
            if (i === 35) {
                text += "ASSUMPTION2;";
                for (let k = 0; k < Object.values(user[i]).length; k++) { text += Object.values(user[i])[k] + ";" }
                text += "\r";
            }
            if (i === 36) {
                text += "ASSUMPTION3;";
                for (let k = 0; k < Object.values(user[i]).length; k++) { text += Object.values(user[i])[k] + ";" }
                text += "\r";
            }
            if (i >= 37 && i <= 44) { text += "PERSONNALITY-TRAITS" + (i - 36) + ";" + user[i][Object.keys(user[i])] + "\r" }
            if (i >= 45 && i <= 59) { text += "VALUE-PREFERENCES" + (i - 44) + ";" + user[i][Object.keys(user[i])] + "\r" }
            if (i >= 60 && i <= 68) { text += "SITUATION-STRATEGY" + (i - 59) + ";" + user[i][Object.keys(user[i])] + "\r" }
            if (i >= 69 && i <= 107) { text += "PTC" + (i - 68) + ";" + user[i][Object.keys(user[i])] + "\r" }
            if (i === 108) {
                text += "REACTIONS-EMOTIONS1;";
                for (let k = 0; k < Object.values(user[i]).length; k++) { text += Object.values(user[i])[k] + ";" }
                text += "\r";
            }
            if (i === 109) {
                text += "REACTIONS-EMOTIONS2;";
                for (let k = 0; k < Object.values(user[i]).length; k++) { text += Object.values(user[i])[k] + ";" }
                text += "\r";
            }
            if (i === 110) {
                text += "REACTIONS-EMOTIONS3;";
                for (let k = 0; k < Object.values(user[i]).length; k++) { text += Object.values(user[i])[k] + ";" }
                text += "\r";
            }
            if (i === 111) {
                text += "REACTIONS-EMOTIONS4;";
                for (let k = 0; k < Object.values(user[i]).length; k++) { text += Object.values(user[i])[k] + ";" }
                text += "\r";
            }
            if (i === 112) {
                text += "REACTIONS-EMOTIONS5;";
                for (let k = 0; k < Object.values(user[i]).length; k++) { text += Object.values(user[i])[k] + ";" }
                text += "\r";
            }
            if (i === 113) {
                text += "LOGIC-TEST1;";
                for (let k = 0; k < Object.values(user[i]).length; k++) { text += Object.values(user[i])[k] + ";" }
                text += "\r";
            }
            if (i === 114) {
                text += "LOGIC-TEST2;";
                for (let k = 0; k < Object.values(user[i]).length; k++) { text += Object.values(user[i])[k] + ";" }
                text += "\r";
            }
            if (i === 115) {
                text += "LOGIC-TEST3;";
                for (let k = 0; k < Object.values(user[i]).length; k++) { text += Object.values(user[i])[k] + ";" }
                text += "\r";
            }
            if (i >= 116 && i <= 130) { text += "HUMAN-VALUES" + (i - 115) + ";" + user[i][Object.keys(user[i])] + "\r" }
            if (i >= 131) { text += "PERSONAL-INFORMATIONS" + (i - 130) + ";" + user[i][Object.keys(user[i])] + "\r" }

        }
        /* let text = "User Inputs \r \r";
        let titles = ["Personality : \r","\r Coping : \r","\r Emotionality : \r","\r Value preferences at work : \r","\r Value preferences : \r",];
        let data = [];
        for (let i = 0; i < user.length; i++) {
          titles.push(user[i].title)
          text += titles[i];
          for (let k = 0; k < user[i].data.length; k++) {
            text += user[i].data[k].subjectEn + " : " + user[i].data[k].user + "\r";
          }
        }
        */
       /*
        let txtContent = "data:text/csv;charset=utf-8," + encodeURIComponent(text);
        let anchor = document.createElement('a');
        anchor.href = "data:" + txtContent;
        anchor.target = '_blank';
        anchor.download = "userInputs.csv";
        anchor.click();
    }
    const _downloadInputsTXT = () => {

        const user = inputs;
        let text = "User Inputs \r \r";
        console.log(user)
        for (let i = 0; i < user.length; i++) {
            if (i >= 0 && i <= 33) { text += Object.keys(user[i]) + " : " + user[i][Object.keys(user[i])] + "\r" }
            if (i === 34) { text += "ASSUMPTION1 : " + Object.values(user[i]) + "\r" }
            if (i === 35) { text += "ASSUMPTION2 : " + Object.values(user[i]) + "\r" }
            if (i === 36) { text += "ASSUMPTION3 : " + Object.values(user[i]) + "\r" }
            if (i >= 37 && i <= 44) { text += "PERSONNALITY-TRAITS" + (i - 36) + " : " + user[i][Object.keys(user[i])] + "\r" }
            if (i >= 45 && i <= 59) { text += "VALUE-PREFERENCES" + (i - 44) + " : " + user[i][Object.keys(user[i])] + "\r" }
            if (i >= 60 && i <= 68) { text += "SITUATION-STRATEGY" + (i - 59) + " : " + user[i][Object.keys(user[i])] + "\r" }
            if (i >= 69 && i <= 107) { text += "PTC" + (i - 68) + " : " + user[i][Object.keys(user[i])] + "\r" }
            if (i === 108) { text += "REACTIONS-EMOTIONS1 : " + Object.values(user[i]) + "\r" }
            if (i === 109) { text += "REACTIONS-EMOTIONS2 : " + Object.values(user[i]) + "\r" }
            if (i === 110) { text += "REACTIONS-EMOTIONS3 : " + Object.values(user[i]) + "\r" }
            if (i === 111) { text += "REACTIONS-EMOTIONS4 : " + Object.values(user[i]) + "\r" }
            if (i === 112) { text += "REACTIONS-EMOTIONS5 : " + Object.values(user[i]) + "\r" }
            if (i === 113) { text += "LOGIC-TEST1 : " + Object.values(user[i]) + "\r" }
            if (i === 114) { text += "LOGIC-TEST2 : " + Object.values(user[i]) + "\r" }
            if (i === 115) { text += "LOGIC-TEST3 : " + Object.values(user[i]) + "\r" }
            if (i >= 116 && i <= 130) { text += "HUMAN-VALUES" + (i - 115) + " : " + user[i][Object.keys(user[i])] + "\r" }
            if (i >= 131) { text += "PERSONAL-INFORMATIONS" + (i - 130) + " : " + user[i][Object.keys(user[i])] + "\r" }

        }
        /* let text = "User Inputs \r \r";
        let titles = ["Personality : \r","\r Coping : \r","\r Emotionality : \r","\r Value preferences at work : \r","\r Value preferences : \r",];
        let data = [];
        for (let i = 0; i < user.length; i++) {
          titles.push(user[i].title)
          text += titles[i];
          for (let k = 0; k < user[i].data.length; k++) {
            text += user[i].data[k].subjectEn + " : " + user[i].data[k].user + "\r";
          }
        }
        */
       /*
        let txtContent = "data:text/txt;charset=utf-8," + encodeURIComponent(text);
        let anchor = document.createElement('a');
        anchor.href = "data:" + txtContent;
        anchor.target = '_blank';
        anchor.download = "userInputs.txt";
        anchor.click();
    }
    const _downloadResultsCSV = () => {

        const user = graphs;
        let text = "User Results \r \r";
        let titles = ["Personality : \r", "\r Coping : \r", "\r Emotionality : \r", "\r Value preferences at work : \r", "\r Value preferences : \r",];
        for (let i = 0; i < user.length; i++) {
            titles.push(user[i].title)
            for (let k = 0; k < user[i].data.length; k++) {
                text += user[i].data[k].en + "; " + user[i].data[k].user + "\r";
            }
        }
        let txtContent = "data:text/csv;charset=utf-8," + encodeURIComponent(text);
        let anchor = document.createElement('a');
        anchor.href = "data:" + txtContent;
        anchor.target = '_blank';
        anchor.download = "userResults.csv";
        anchor.click();
    }
    const _downloadResultsTXT = () => {

        const user = graphs;
        let text = "User Results \r \r";
        let titles = ["\rPersonality : \r\r", "\r\rCoping : \r\r", "\r\rEmotionality : \r\r", "\r\rValue preferences at work : \r\r", "\r\rValue preferences : \r\r",];
        for (let i = 0; i < user.length; i++) {
            titles.push(user[i].title);
            text += titles[i];
            for (let k = 0; k < user[i].data.length; k++) {
                text += user[i].data[k].en + " : " + user[i].data[k].user + "\r";
            }
        }
        let txtContent = "data:text/txt;charset=utf-8," + encodeURIComponent(text);
        let anchor = document.createElement('a');
        anchor.href = "data:" + txtContent;
        anchor.target = '_blank';
        anchor.download = "userResults.txt";
        anchor.click();
    }
    const imageGroupComparison = () => {
        if (locale === 'en') return { GroupComparison_en }
        if (locale === 'fr') return { GroupComparison_fr }
        if (locale === 'de') return { GroupComparison_de }
        else return { GroupComparison_en }
    }
    const restartTest = () => {
        // eslint-disable-next-line no-restricted-globals
        if (confirm('Êtes-vous sûr de vouloir recommencer le test ?')) {
            if (sessionStorage.getItem('step')) {
                sessionStorage.removeItem('step')
            }
            history.push('/')
        }
        else {
            alert("annulation")
        }
    }
    */
    
    return (
        <div>
            {
                loading ?
                    <div style={{ width: "100vw", height: "100vh", zIndex: '99999', color: "black", position: 'fixed', top: "0", left: "0", fontSize: "20px", display: "flex", justifyContent: "center", alignItems: "center", flexDirection: "column" }}>
                        <FormattedMessage {...messages.LOADING_PAGE}>
                            {(msg) => (<h3>{msg}</h3>)}
                        </FormattedMessage>
                    </div>
                    :
                    <div className="Graphs">
                        
                            {
                                !showResults && <div className="Graphs-header-no-report">
                                        <h1 className="Graphs-title title-spacer">{/*<FormattedMessage {...messages.TITRE} />*/}</h1>
                                        <h2 className="Graphs-h2 "><FormattedMessage {...messages.SCOPEREPORT_GUIDE_TITLE_1} /></h2><p className="Graphs-informations"><FormattedMessage {...messages.SCOPEREPORT_GUIDE_PARAGRAPH_1_1_A} /></p><p className="Graphs-informations"><FormattedMessage {...messages.SCOPEREPORT_GUIDE_PARAGRAPH_1_1_B} /></p>
                                </div>
                            }
                            {
                                showResults && <div className="Graphs-header">
                                                <h1 className="Graphs-title"><FormattedMessage {...messages.TITRE} /></h1>
                                                <h2 className="Graphs-h2 "><FormattedMessage {...messages.SCOPEREPORT_GUIDE_TITLE_1} /></h2>
                                                <p className="Graphs-informations"><FormattedMessage {...messages.SCOPEREPORT_GUIDE_PARAGRAPH_1_1} /></p>
                                        
                                            
                                                <h2 className="Graphs-h2 "><FormattedMessage {...messages.SCOPEREPORT_GUIDE_TITLE_2} /></h2>
                                                <p className="Graphs-informations"><FormattedMessage {...messages.SCOPEREPORT_GUIDE_PARAGRAPH_2_1} /></p>
                                                <p className="Graphs-informations"><FormattedMessage {...messages.SCOPEREPORT_GUIDE_PARAGRAPH_2_2} /></p>
                                                <p className="Graphs-informations"><FormattedMessage {...messages.SCOPEREPORT_GUIDE_PARAGRAPH_2_3} /></p>
                                                <p className="Graphs-informations"><FormattedMessage {...messages.SCOPEREPORT_GUIDE_PARAGRAPH_2_4} /></p>
                                                <div className="Graphs-extra-info" style={{ margin: '20px 0px' }}>
                                                    <p><FormattedMessage {...messages.SCOPEREPORT_GUIDE_PARAGRAPH_2_5} /></p>
                                                    <p><FormattedMessage {...messages.SCOPEREPORT_GUIDE_PARAGRAPH_2_6} /></p>
                                                </div>
                                                <p className="Graphs-informations"><FormattedMessage {...messages.SCOPEREPORT_GUIDE_PARAGRAPH_2_7} /></p>
                                                <div className="graph-spacer"></div>
                                                <h2 className="Graphs-h2 "><FormattedMessage {...messages.SCOPEREPORT_GUIDE_TITLE_3} /></h2>
                                                <p className="Graphs-informations"><FormattedMessage {...messages.SCOPEREPORT_GUIDE_PARAGRAPH_3_1} /></p>
                                                <div style={{ width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center', alignContent: 'center' }}>
                                                    {
                                                        locale === 'en' ? <img alt='comparison-group' style={{ width: '80%' }} src={GroupComparison_en}></img> : null
                                                    }
                                                    {
                                                        locale === 'fr' ? <img alt='comparison-group' style={{ width: '80%' }} src={GroupComparison_fr}></img> : null
                                                    }
                                                    {
                                                        locale === 'de' ? <img alt='comparison-group' style={{ width: '80%' }} src={GroupComparison_de}></img> : null
                                                    }
                                                </div>
                                                <p className="Graphs-informations"><FormattedMessage {...messages.SCOPEREPORT_GUIDE_PARAGRAPH_3_2} /></p>
                                                <p className="Graphs-informations"><FormattedMessage {...messages.SCOPEREPORT_GUIDE_PARAGRAPH_3_3} /></p>
                                                <p className="Graphs-informations"><FormattedMessage {...messages.SCOPEREPORT_GUIDE_PARAGRAPH_3_4} /></p>
                                                <p className="Graphs-informations"><FormattedMessage {...messages.SCOPEREPORT_GUIDE_PARAGRAPH_3_5} /></p>
                                                <div className="Graphs-extra-info" style={{ margin: '60px 0px' }}>
                                                    <p style={{ textAlign: 'left' }}><FormattedMessage {...messages.SCOPEREPORT_RESULTSINFO} /></p>
                                                    <p><FormattedMessage {...messages.SCOPEREPORT_SEE_RESULTS} /></p>
                                                </div>
                                </div>
                              }
                        
                        <div className="Graphs-graphs">
                            {/*<PageCharts dataForGraphs={graphs} currentLanguage={locale} />*/}
                        </div>
                        <a className="Graphs-sign-out" href="https://ppe-evaluation.com"><FormattedMessage {...messages.BTNLOGOUT} /></a>
                    </div>
            }
        </div>
    );
}
